import { Column, Table } from '@tanstack/react-table';
import React from 'react';
import Form from 'react-bootstrap/Form';

type SelectFilterProps = {
  column: Column<any, unknown>;
  table: Table<any>;
  options: Array<{ value: string; label: string }>;
};

export default function SelectFilter({
  column,
  options,
}: SelectFilterProps) {
  const columnFilterValue = column.getFilterValue();

  return (
    <Form.Select
      size="sm"
      value={String(columnFilterValue || '')}
      onChange={(e) => {
        const value = e.target.value;
        column.setFilterValue(value === '' ? undefined : value);
      }}>
      {options.map((option) => (
        <option key={option.value} value={option.value}>
          {option.label}
        </option>
      ))}
    </Form.Select>
  );
}
